import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1e950379"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h1", null, "Create an event", -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Name & describe your event", -1))
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "When and where is your event?", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Pets", -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "Are pets allowed?", -1))
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("legend", null, "Extras", -1))
const _hoisted_7 = /*#__PURE__*/_createTextVNode("Submit")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_BaseInput = _resolveComponent("BaseInput")!
  const _component_BaseRadioGroup = _resolveComponent("BaseRadioGroup")!
  const _component_BaseCheckbox = _resolveComponent("BaseCheckbox")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_container = _resolveComponent("v-container")!
  const _component_v_form = _resolveComponent("v-form")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!

  return (_openBlock(), _createBlock(_component_v_container, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        justify: "center",
        "no-gutters": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, {
            cols: "12",
            sm: "8"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card, null, {
                default: _withCtx(() => [
                  _createVNode(_component_v_form, {
                    onSubmit: _withModifiers($setup.onSubmit, ["prevent"])
                  }, {
                    default: _withCtx(() => [
                      _hoisted_1,
                      _createVNode(_component_v_container, null, {
                        default: _withCtx(() => [
                          _createVNode(_component_v_row, {
                            justify: "center",
                            "no-gutters": ""
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_select, {
                                items: $data.categories,
                                modelValue: $setup.event.category,
                                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.event.category) = $event)),
                                label: "Select a category:",
                                "error-messages": $setup.errors.category,
                                solo: ""
                              }, null, 8, ["items", "modelValue", "error-messages"]),
                              _createElementVNode("fieldset", null, [
                                _hoisted_2,
                                _createVNode(_component_v_text_field, {
                                  label: "Title",
                                  type: "text",
                                  modelValue: $setup.event.title,
                                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.event.title) = $event)),
                                  "error-messages": $setup.errors.title
                                }, null, 8, ["modelValue", "error-messages"]),
                                _createVNode(_component_v_text_field, {
                                  label: "Description",
                                  type: "text",
                                  modelValue: $setup.event.description,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.event.description) = $event)),
                                  "error-messages": $setup.errors.description
                                }, null, 8, ["modelValue", "error-messages"])
                              ]),
                              _createElementVNode("fieldset", null, [
                                _hoisted_3,
                                _createVNode(_component_v_text_field, {
                                  label: "Location",
                                  type: "text",
                                  modelValue: $setup.event.location,
                                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.event.location) = $event)),
                                  "error-messages": $setup.errors.location
                                }, null, 8, ["modelValue", "error-messages"]),
                                _createVNode(_component_BaseInput, {
                                  label: "Date",
                                  type: "date",
                                  modelValue: $setup.event.date,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.event.date) = $event)),
                                  error: $setup.errors.date
                                }, null, 8, ["modelValue", "error"]),
                                _createVNode(_component_BaseInput, {
                                  label: "Time",
                                  type: "time",
                                  modelValue: $setup.event.time,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.event.time) = $event)),
                                  error: $setup.errors.time
                                }, null, 8, ["modelValue", "error"])
                              ]),
                              _createElementVNode("fieldset", null, [
                                _hoisted_4,
                                _hoisted_5,
                                _createVNode(_component_BaseRadioGroup, {
                                  modelValue: $setup.event.petsAllowed,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.event.petsAllowed) = $event)),
                                  name: "pets",
                                  options: $data.petOptions,
                                  vertical: ""
                                }, null, 8, ["modelValue", "options"])
                              ]),
                              _createElementVNode("fieldset", null, [
                                _hoisted_6,
                                _createVNode(_component_BaseCheckbox, {
                                  modelValue: $setup.event.extras.catering,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.event.extras.catering) = $event)),
                                  label: "Catering"
                                }, null, 8, ["modelValue"]),
                                _createVNode(_component_BaseCheckbox, {
                                  modelValue: $setup.event.extras.music,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.event.extras.music) = $event)),
                                  label: "Live music"
                                }, null, 8, ["modelValue"])
                              ]),
                              _createVNode(_component_BaseButton, { type: "submit" }, {
                                default: _withCtx(() => [
                                  _hoisted_7
                                ]),
                                _: 1
                              })
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }, 8, ["onSubmit"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}